/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateSetupTaskRequestBody,
  UpdateSetupTaskRequestBody$Outbound,
  UpdateSetupTaskRequestBody$outboundSchema,
} from "../components/updatesetuptaskrequestbody.js";

export type UpdateSetupTaskSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateSetupTaskRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateSetupTaskRequestBody: UpdateSetupTaskRequestBody;
};

/** @internal */
export type UpdateSetupTaskSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateSetupTaskSecurity$outboundSchema: z.ZodMiniType<
  UpdateSetupTaskSecurity$Outbound,
  UpdateSetupTaskSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateSetupTaskSecurityToJSON(
  updateSetupTaskSecurity: UpdateSetupTaskSecurity,
): string {
  return JSON.stringify(
    UpdateSetupTaskSecurity$outboundSchema.parse(updateSetupTaskSecurity),
  );
}

/** @internal */
export type UpdateSetupTaskRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateSetupTaskRequestBody: UpdateSetupTaskRequestBody$Outbound;
};

/** @internal */
export const UpdateSetupTaskRequest$outboundSchema: z.ZodMiniType<
  UpdateSetupTaskRequest$Outbound,
  UpdateSetupTaskRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateSetupTaskRequestBody: UpdateSetupTaskRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateSetupTaskRequestBody: "UpdateSetupTaskRequestBody",
    });
  }),
);

export function updateSetupTaskRequestToJSON(
  updateSetupTaskRequest: UpdateSetupTaskRequest,
): string {
  return JSON.stringify(
    UpdateSetupTaskRequest$outboundSchema.parse(updateSetupTaskRequest),
  );
}
